import {
  ClientProfileFormShape,
  ClientProfileRelationshipFormShape,
} from '@/modules/clientProfiles/ClientProfile.types';
import { ClientProfileDisplayNamePattern } from '@/types/schema';
import { PathsOf } from '@/types/subform';

export interface UpdateHouseholdFormShape {
  primaryRelationshipOwnerId: string;
  subBrandId: string;
  teamIds: string[];
  _initialTeamIds: string[];
  isProspect: boolean;
  profiles: ClientProfileFormShape[];
}

export type UpdateHouseholdFormPaths = PathsOf<UpdateHouseholdFormShape>;

interface GetEmptyClientProfileArgs {
  relationshipOptions: ClientProfileRelationshipFormShape[];
}

export function getEmptyClientProfileValue({
  relationshipOptions,
}: GetEmptyClientProfileArgs): ClientProfileFormShape {
  return {
    id: null,
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    preferredName: '',
    displayNamePattern: ClientProfileDisplayNamePattern.FirstLastSuffix,
    email: '',
    address: {
      id: null,
      cityName: '',
      stateCode: '',
      residesOutsideUnitedStates: false,
    },
    dateOfBirth: null,
    dateOfDeath: null,
    isGrantor: true,
    relationships: relationshipOptions,
    notes: '',
    isDeceased: false,
  };
}
